import { Box, Grid, Typography, IconButton } from "@mui/material";
import { Fragment, React, useState } from "react";
import { gradientColor } from "../../../contants";
import CallMadeIcon from "@mui/icons-material/CallMade";
import { useNavigate } from "react-router";
import { colors } from "../../../assets/colors";
import FlexButton from "../../../components/FlexButton";
import PreviewModal from "../../../components/modals/PreviewModal";
// import { AnimationOnScroll } from "react-animation-on-scroll";

export default function TaralProducts({ themeSettings }) {
  const isDark = themeSettings.settings.theme === "DARK" ? true : false;
  const stepsData = [
    {
      title: "Taral Earn",
      description:
        "Taral Earn revolutionizes crypto investment by offering you an exclusive chance to acquire digital assets at discounted rates. Here's how it works: users purchase crypto through Taral Earn at a reduced price and later sell it on the market for potential profits. This innovative platform opens doors for investors to maximize their returns while minimizing initial investment costs. Don't miss out on the opportunity to elevate your investment game with Taral Earn!",
      image: "/assets/images/taral-earn.png",
      href: "/product-taral-earn",
    },
    {
      title: "Taral Drop",
      description:
        "Taral Drop is your gateway to free crypto rewards! By participating in Taral Drop, you stand a chance to claim complimentary coins or tokens. It's a unique opportunity to enhance your crypto portfolio without any upfront investment. Don't miss out on this exclusive chance to earn free crypto with Taral Drop!",
      image: "/assets/images/taral-drop.png",
      href: "/product-taral-drop",
    },
  ];

  const [selectedStep, setSelectedStep] = useState(null);

  return (
    <Box className="mainContainer" sx={{ margin: "100px 0px" }}>
      <Grid container spacing={3} className="displayCenter">
        <Grid item lg={12} xs={12} md={12} sm={12}>
          <Box>
            {/* <AnimationOnScroll animateIn="animate__fadeInUp"> */}
            <Typography variant="h2" sx={gradientColor}>
              Our Hot Products
            </Typography>
            {/* </AnimationOnScroll> */}
          </Box>
          <Box mt={2}>
            <Grid container spacing={2}>
              {stepsData &&
                stepsData.map((data, i) => {
                  return (
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={12}
                      key={`products-${i}`}
                    >
                      <ViewCard data={data} isDark={isDark} />
                    </Grid>
                  );
                })}
            </Grid>
          </Box>
          {/* <Box
            sx={{
              marginTop: "30px",
              cursor: "pointer",
            }}
          >
            {stepsData &&
              stepsData.map((item, index, href) => {
                return (
                  <StepCard
                    item={item}
                    index={index}
                    key={`xard${index}`}
                    setSelectedStep={setSelectedStep}
                    href={href}
                    navigate={navigate}
                  />
                );
              })}
          </Box> */}
        </Grid>
        {/* <Grid item lg={6} xs={12} md={6} sm={6} className="displayCenter">
          <Box mt={2}>
            {selectedStep !== null ? (
              <Box>
                <img
                  src={stepsData[selectedStep].image}
                  alt={`step-${selectedStep + 1}`}
                  style={{ width: "100%", maxWidth: "550px" }}
                  // style={{ maxWidth: "850px" }}
                />
              </Box>
            ) : (
              <img
                src="/assets/images/default.png"
                alt="default"
                width="100%"
                style={{ maxWidth: "550px" }}
              />
            )}
          </Box>
        </Grid> */}
      </Grid>
    </Box>
  );
}
const StepCard = ({ item, index, setSelectedStep, navigate }) => {
  const clickHandler = () => {
    if (navigate) {
      navigate(item?.href);
    } else {
      console.error("Navigate function not provided!");
    }
  };
  return (
    <Box
      className="displayStart"
      sx={{
        padding: "20px 0px",
        "&:hover": {
          transform: "scale(1.1)",
          zIndex: "2",
          transition: "ease-in-out",
          transitionDuration: "0.25s",
          // border: "2px solid gold",
          // borderRadius: "50px",
        },
        // "&:hover": {
        //     border: "2px solid gold",
        //     borderRadius: "50px",
        //     boxShadow: "5px 5px 5px rgba(128, 128, 128, 1)",
        //     transform: "translateY(-8px)",
        // },
      }}
      onMouseOver={() => setSelectedStep(index)}
      onClick={clickHandler}
    >
      <Box>
        <img
          src="/assets/icons/tick_square.png"
          alt="tick"
          style={{ marginRight: "12px" }}
        />
      </Box>
      <Box>
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <Typography variant="h5" sx={{ color: "#FFCA65" }}>
            {item?.title}
          </Typography>
          <Box>
            <IconButton>
              <CallMadeIcon sx={{ padding: "2px" }} />
            </IconButton>
          </Box>
        </Box>
        <Typography variant="body1">{item?.description}</Typography>
      </Box>
    </Box>
  );
};

const ViewCard = ({ data, isDark }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <Fragment>
      <Box
        sx={{
          position: "relative",
          zIndex: "1",
        }}
      >
        <Box className={isDark ? "flexBox" : "flexBoxLight"}>
          <Box
            style={{ position: "relative", zIndex: "999", minHeight: "188px" }}
            align="center"
          >
            <figure
              style={{
                minHeight: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={data?.image}
                alt={data?.title}
                style={{ width: "100%", maxWidth: "150px", minHight: "150px" }}
              />
            </figure>
            <Box align="center">
              <Typography variant="h6">{data?.title}</Typography>

              <Typography variant="body2" mt={1} align="center">
                {data?.description && data?.description.length > 100
                  ? `${data?.description?.slice(0, 90)}...`
                  : data?.description}
                <Typography
                  variant="body2"
                  mt={1}
                  fontWeight={600}
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      color: colors.btnGold,
                    },
                  }}
                  onClick={() => setOpen(true)}
                >
                  Read more
                </Typography>
              </Typography>

              <FlexButton
                color="primary"
                title="Explore"
                onClick={() => navigate(data.href)}
                sx={{ padding: "4px", marginTop: "12px" }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      {open && (
        <PreviewModal
          open={open}
          close={() => setOpen(false)}
          title={data?.title}
          text={data?.description}
          img={true}
          url={data?.image}
        />
      )}
    </Fragment>
  );
};
